export function validateDataForFields(data) {
   

    if(data&&data!=""&&data!=undefined)
    {
        return data 
    }
    else{

        return undefined
    }
}

export const createDropdownValues = (data) => {
    let res = [];
    if (data && data.length > 0) {
      data.map((each) => {
        res.push({ option: each, value: each });
      });
    }

    return res;
  };

  export const convertObjectToArray = (data, keyName) => {
  
    let resp = [];
  
    if (data && data.length > 0 && keyName ) {
      data.map((each) => {
        resp.push(each[keyName]);
      });
    }
  
    return resp;
  };

  export const convertToSelectData = (data, keyName, valueName) => {
    let resp = [];
  
    if (data && data.length > 0 && keyName && valueName) {
      data.map((each) => {
        resp.push({ value: each[valueName], label: each[keyName] });
      });
    } else if (data && data.length > 0 && !keyName && !valueName) {
      data.map((each) => {
        resp.push({ value: each, label: each });
      });
    }
  
    return resp;
  };

  export const createDropdownValuesNative = (data) => {
    let res = [];
    if (data && data.length > 0) {
      data.map((each) => {
        res.push({ label: each, value: each });
      });
    }

    return res;
  };

  export const getKeysOfObject = (object) => {
    if (object) {
      return Object.keys(object);
    } else {
      return [];
    }
  };